import * as React from "react";
import styled from "styled-components";
import ElementDimensions from "components/common/ElementDimensions";
import AutoFontSizer from "views/components/visualizations/number/AutoFontSizer";
import WidgetCard from "views/components/widgets/WidgetCard";
import WidgetContentSkeleton from "views/components/widgets/WidgetContentSkeleton";
import { ReplaySearchButtonComponent } from "views/components/widgets/ReplaySearchButton";
import { KPI_WIDGET_HEIGHT } from "../Constants";
const SizedWidgetCard = styled(WidgetCard)`
  min-width: 0;

  /* Matches the rendered height of the search-backed KPI widgets. */
  height: ${KPI_WIDGET_HEIGHT};
`;
const NumberArea = styled.div`
  flex: 1;
  min-height: 0;
`;
const NumberBox = styled(ElementDimensions)`
  height: 100%;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  max-height: 72px;
`;
const ValueText = styled.span`
  /* Match search-backed numeric widgets, which derive the value text color from the widget background. */
  color: ${({ theme }) => theme.utils.contrastingColor(theme.colors.global.contentBackground)};
`;
const SubLabel = styled.small`
  font-size: ${({ theme }) => theme.fonts.size.large};
  color: ${({ theme }) => theme.colors.text.secondary};
  min-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
`;
const NumberCard = ({
  value,
  label,
  subLabel = void 0,
  replayLink = void 0,
  onClick = void 0,
  loading = false
}) => /* @__PURE__ */ React.createElement(
  SizedWidgetCard,
  {
    headline: label,
    timeRangeInfo: "All Time",
    actions: replayLink && /* @__PURE__ */ React.createElement(ReplaySearchButtonComponent, { searchLink: replayLink }),
    onClick
  },
  loading ? /* @__PURE__ */ React.createElement(WidgetContentSkeleton, { visualization: "numeric" }) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NumberArea, null, /* @__PURE__ */ React.createElement(NumberBox, { resizeDelay: 50 }, ({ height, width }) => /* @__PURE__ */ React.createElement(AutoFontSizer, { height, width, alignment: "bottom-left" }, /* @__PURE__ */ React.createElement(ValueText, null, value)))), subLabel && /* @__PURE__ */ React.createElement(SubLabel, null, subLabel))
);
export default NumberCard;
